
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs,
              ...rest,
            },
            children.concat([_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 24"}},[_c('path',{attrs:{"d":"M17.579 18.412H2.576a1.608 1.608 0 01-1.498-2.199l.483-1.232c.708-1.804 1.2-3.68 1.474-5.597l.37-2.585a6.739 6.739 0 016.668-5.782c1.684 0 3.23.612 4.422 1.643A6.74 6.74 0 0116.75 6.8l.362 2.584a25.381 25.381 0 001.482 5.597l.483 1.232a1.608 1.608 0 01-1.498 2.2zm-4.05 1.076a3.45 3.45 0 01-6.901 0","fill":"none","fill-rule":"evenodd","stroke":"currentColor","stroke-linecap":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    